import { render, staticRenderFns } from "./Acknowledgement.vue?vue&type=template&id=5b105d3b&scoped=true&"
import script from "./Acknowledgement.vue?vue&type=script&lang=js&"
export * from "./Acknowledgement.vue?vue&type=script&lang=js&"
import style0 from "./Acknowledgement.vue?vue&type=style&index=0&id=5b105d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b105d3b",
  null
  
)

export default component.exports